<template>
    <c-dialog ref="dialog" title="资产归还单详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.return_code" class="m-detail-tag flex-center-cross">
                <label>{{detailData.return_title || detailData.return_code}}</label>
                <c-state dict="returnStatusDic" tag :value="detailData.return_status"></c-state>
            </div>
        </template>
        
		<doc-base>
			<template #title>{{detailData.apply_user_name}}_资产归还单</template>

			<template #info>
				<c-field label="单据编号">{{detailData.apply_code}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="关联领用单">{{detailData.receive_apply_code}}</c-field>
			<c-field label="归还时间">{{detailData.return_time}}</c-field>
			<c-field label="归还资产明细" vertical>
                <c-table :data="detailData.item_list" border :paging="false">
                    <c-table-column
                        label="资产编号"
                        name="asset_code"
                        width="120"
                    ></c-table-column>
                    <c-table-column
                        label="资产名称"
                        name="asset_name"
                    ></c-table-column>
                    <c-table-column
                        label="资产分类"
                        name="asset_category"
                    ></c-table-column>
                    <c-table-column
                        label="领用数量"
                    >
                        <template #default="{data}">
                            {{data.return_quantity}}{{data.unit_name}}
                        </template>
                    </c-table-column>
					<c-table-column
                        label="凭证"
                        width="300"
                    >
                        <template #default="{data}">
						    <c-file-list :value="data.voucher_image_url"></c-file-list>
                        </template>
					</c-table-column>
                </c-table>
			</c-field>
			<c-field label="备注">{{detailData.remark}}</c-field>
		</doc-content>

		<doc-handle
			ref="docHandle"
			:status="detailData.apply_status"
			:applicant="detailData.is_founder == 1"
			@update="getDetail"
		></doc-handle>
    </c-dialog>
</template>

<script>
export default {
    name: 'assetReturnDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.getDetail();
            this.$refs.dialog.open();
        },

        getDetail() {
            this.request({
                url: '/asset_return_apply/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
